import { AcornsIcon } from '@acorns/icons'
import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const AddressCard = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 400px;
  padding: 20px;
  margin: auto;
  border: ${props => (props.selected ? 'none' : style(theme => `1px solid ${theme.colors.ivory}`))};
  box-shadow: ${props => (props.selected ? ' 0px 3px 15px 2px rgba(0, 0, 0, 0.05);' : 'none')};
  border-radius: ${style(theme => theme.borderRadius.large)};

  &:first-child {
    margin-bottom: 20px;
  }
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

const AddressCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px auto 80px;
`

const AddressHeader = styled.h2`
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  margin: 0 0 5px 0;
  color: ${style(theme => theme.colors.slate)};
`

const AddressBody = styled.div`
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${style(theme => theme.colors.slate)};
`

const SelectedIcon = styled(AcornsIcon)`
  align-self: center;
`

const AddressCardInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledButton = styled(Button)`
  margin: auto;
  width: 220px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 0;
    width: 100%;
  }
`
export {
  AddressCard,
  AddressCardContainer,
  SelectedIcon,
  AddressHeader,
  AddressBody,
  AddressCardInnerContainer,
  StyledButton,
}
